import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

const Widget = ({ title, subTitle, Icon, to }) => {
	return (
		<Card
			className="w-full rounded-20 shadow cursor-pointer"
			component={Link}
			to={to}
		>
			<div className="py-20 px-10">
				<div className="flex">
					{Icon && <Icon sx={{ fontSize: 40 }} className="mr-8" />}
					<div>
						<Typography className="h3 font-medium">{title}</Typography>
						<div className="flex flex-col">
							<div className="flex items-center">
								<Typography className="mx-4" color="textSecondary">
									{subTitle}
								</Typography>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Card>
	);
};

export default Widget;
